import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("Home")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Subscriptions")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Rewards")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("More")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_router_outlet = _resolveComponent("ion-router-outlet")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_tab_button = _resolveComponent("ion-tab-button")!
  const _component_ion_tab_bar = _resolveComponent("ion-tab-bar")!
  const _component_ion_tabs = _resolveComponent("ion-tabs")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_tabs, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_router_outlet),
          _createVNode(_component_ion_tab_bar, {
            class: "ion-padding-vertical ios-pb-30 font-sans",
            slot: "bottom"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_tab_button, {
                tab: "dashboard",
                href: "/dashboard"
              }, {
                default: _withCtx(() => [
                  (_ctx.route !== 'dashboard')
                    ? (_openBlock(), _createBlock(_component_ion_icon, {
                        key: 0,
                        icon: _ctx.homeOutline
                      }, null, 8, ["icon"]))
                    : (_openBlock(), _createBlock(_component_ion_icon, {
                        key: 1,
                        icon: _ctx.home
                      }, null, 8, ["icon"])),
                  _createVNode(_component_ion_label, null, {
                    default: _withCtx(() => [
                      _hoisted_1
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_tab_button, {
                tab: "my-subscriptions",
                href: "/my-subscriptions"
              }, {
                default: _withCtx(() => [
                  (_ctx.route !== 'mySubscriptions')
                    ? (_openBlock(), _createBlock(_component_ion_icon, {
                        key: 0,
                        icon: _ctx.shirtOutline
                      }, null, 8, ["icon"]))
                    : (_openBlock(), _createBlock(_component_ion_icon, {
                        key: 1,
                        icon: _ctx.shirt
                      }, null, 8, ["icon"])),
                  _createVNode(_component_ion_label, null, {
                    default: _withCtx(() => [
                      _hoisted_2
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_tab_button, {
                tab: "loyalty",
                href: "/loyalty"
              }, {
                default: _withCtx(() => [
                  (_ctx.route !== 'loyalty')
                    ? (_openBlock(), _createBlock(_component_ion_icon, {
                        key: 0,
                        icon: _ctx.giftOutline
                      }, null, 8, ["icon"]))
                    : (_openBlock(), _createBlock(_component_ion_icon, {
                        key: 1,
                        icon: _ctx.gift
                      }, null, 8, ["icon"])),
                  _createVNode(_component_ion_label, null, {
                    default: _withCtx(() => [
                      _hoisted_3
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_tab_button, {
                tab: "account",
                href: "/account"
              }, {
                default: _withCtx(() => [
                  (_ctx.route !== 'account')
                    ? (_openBlock(), _createBlock(_component_ion_icon, {
                        key: 0,
                        icon: _ctx.ellipsisHorizontalOutline
                      }, null, 8, ["icon"]))
                    : (_openBlock(), _createBlock(_component_ion_icon, {
                        key: 1,
                        icon: _ctx.ellipsisHorizontal
                      }, null, 8, ["icon"])),
                  _createVNode(_component_ion_label, null, {
                    default: _withCtx(() => [
                      _hoisted_4
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}